/* eslint-disable react/no-array-index-key */
import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';
import { Council, Society } from 'types';

import CustomLoading from 'modules/_shared/components/CustomLoading';
import { useGetAdministrativesSectionPermissions } from 'modules/administratives/hooks/useGetAdministrativesSectionPermissions';

import CouncilMembersDocumentsCardGroup from './CouncilMembersDocumentsCardGroup';
import useCouncilMenuOptions from '../hooks/useCouncilMenuOptions';
import { generateDocumentGroups } from '../utils/generateDocumentGroups';
import MembersDocumentsSection from '../../CouncilDetails/components/MembersDocumentsSection';

type CouncilMembersDocumentsCardProps = {
  council: Council;
  documents: any;
  society: Society;
  isAdminView: boolean;
};

const CouncilMembersDocumentsCard: FC<CouncilMembersDocumentsCardProps> = ({
  council,
  documents,
  society,
  isAdminView,
}) => {
  const { t } = useTranslate();

  const { isAdmin } = useGetAdministrativesSectionPermissions().data;

  const { announcementItems, actItems, signItems } = generateDocumentGroups(
    council,
    documents,
    society,
    t,
    isAdmin
  );

  const {
    data: {
      getAnnouncementMenuOptions,
      getActMenuOptions,
      getSignaturesMenuOptions,
    },
    actions: {
      handleEditAnnouncement,
      handleEditAct,
      handleEditSignatures,
      handleClickDocument,
    },
    isLoading,
  } = useCouncilMenuOptions({
    council,
    isAdminView,
  });

  return (
    <section className="council-member-basic-info-card col px-0 pl-2">
      <CouncilMembersDocumentsCardGroup
        title={t('Announcement')}
        items={announcementItems}
        isAdmin={isAdminView}
        onEdit={isAdminView ? handleEditAnnouncement : undefined}
        getMenuOptionsForItem={getAnnouncementMenuOptions}
        onSeeDocument={handleClickDocument}
      />

      <CouncilMembersDocumentsCardGroup
        title={t('Act')}
        items={actItems}
        isAdmin={isAdminView}
        onEdit={isAdminView ? handleEditAct : undefined}
        getMenuOptionsForItem={getActMenuOptions}
        onSeeDocument={handleClickDocument}
      />

      <CouncilMembersDocumentsCardGroup
        title={t('Signatures')}
        items={signItems}
        isAdmin={isAdminView}
        onEdit={isAdminView ? handleEditSignatures : undefined}
        getMenuOptionsForItem={getSignaturesMenuOptions}
        onSeeDocument={handleClickDocument}
      />

      <MembersDocumentsSection
        council={council}
        fetchCouncilData={() => {}}
        isAdminView={isAdminView}
      />

      {isLoading && <CustomLoading />}
    </section>
  );
};

export default CouncilMembersDocumentsCard;
